exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-card[data-v-e7ef0df6]{width:98%;margin:2vh auto;padding:1vh;border-radius:6px;-webkit-box-shadow:0 1px 4px 1px #9f9c9c;box-shadow:0 1px 4px 1px #9f9c9c}.box-card>p[data-v-e7ef0df6]{font-size:.85vw;font-weight:700;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7ef0df6","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/console/accountPage/components/signSettings.vue
// module id = qAjH
// module chunks = 0 28 34